import {useRouter} from "vue-router";
import {AdminRouteNames, AuthRouteNames, CustomerRouteNames} from "@app/router/route-names";

export const useNavigation = () => {
  const router = useRouter();

  const goBack = () => {
    router.back();
  }

  const goTo = (route: CustomerRouteNames | AdminRouteNames | AuthRouteNames, args?: {
    method?: 'replace' | 'push',
    params?: Record<string, any>,
    query?: Record<string, any>,
  }) => {
    const {method = 'push', params, query} = args || {};

    router[method]({name: route, params, query});
  }
  return {
    goBack, goTo
  }
}
